export function validateArchiveForm (data) {
    let errors = {};    
    // if (!data.title || data.title == '' || data.title == ' ')
    //     errors.title = 'Title is required';
    
    // if (!data.authors || data.authors == '' || data.authors == ' ') 
    //     errors.authors = 'Authors are required';
    
    if (!data.archive || data.archive == '' || data.archive == ' ')
        errors.archive = 'Archive is required';
    
    if (!data.trust || data.trust == '' || data.trust == ' ')
        errors.trust = 'Trust is required';
    
    
    if (!data.crate || data.crate == null)
        errors.crate = 'Crate is required';
    
    if (!data.doc_number || data.doc_number == '' || data.doc_number == ' ')
        errors.doc_number = 'Document number is required';
    
    if (Object.keys(errors).length > 0) {
        return errors;
    } else {
        return true;
    }
}